import {
    HeaderClassName,
    labelClassName,
    pxArrayToRem,
    pxToRem,
} from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';

export const PageTopSectionWrapper: StyleRule = () => ({
    padding: pxArrayToRem([130, 50, 0, 50]),
});

export const PageTopSection: StyleRule = () => ({
    paddingBottom: 0,
    marginBottom: pxToRem(112),
    alignItems: 'flex-start',
});

export const TitleWrapper: StyleRule = ({ theme }) => ({
    position: 'relative',
    flex: 2.25,

    [`& .${HeaderClassName}`]: {
        position: 'relative',
        display: 'inline',
        color: theme.siteVariables.colorScheme.default?.foreground,
        textTransform: 'uppercase',
        letterSpacing: '-0.02em',
        lineHeight: 1,
        fontSize: pxToRem(80),
        ...theme.siteVariables.textStyles.Heading.Roman55,
    },
});

export const CategoryCountWrapper: StyleRule = ({ theme }) => ({
    position: 'absolute',
    display: 'inline-block',
    margin: pxToRem(8),
    verticalAlign: 'top',
    color: theme.siteVariables.colorScheme.default?.foreground,
    fontSize: pxToRem(18),
});

export const CategoryDescriptionWrapper: StyleRule = ({
    theme,
    viewAllDescription,
    showCategoryTitle,
}) => ({
    flex: 1,
    paddingRight: pxToRem(72),
    marginLeft: pxToRem(showCategoryTitle ? 64 : 0),
    maxWidth: pxToRem(850),

    [`& .${labelClassName}`]: {
        color: theme.siteVariables.colorScheme.default?.foreground,
        fontSize: pxToRem(16),
        lineHeight: theme.siteVariables.lineHeightSmall,
        cursor: viewAllDescription ? 'auto' : 'pointer',
        '& p': {
            margin: 0,
        },
    },
});

export const BreadcrumbWrapper: StyleRule = () => ({
    paddingBottom: pxToRem(40),
});
